const initialState = {
  app: {
    status: "inactive", // inactive, load, active, error
    error: null,
    message: ""
  },
  data: {
    childGuid: null,
    rflgrouping: null,
    emailallowed: false, 
    childData: {},
    mediaData: {}
  }
};

export default initialState;